export default class ResponseError extends Error {
  constructor() {
    super('Response received')
    Object.setPrototypeOf(this, ResponseError.prototype)
    this.name = 'ResponseError'
  }
}
